<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card-title>Image colors by percentage</v-card-title>
        <v-card-text>
          <BarChart :headers="dateUsage.headers" :data="dateUsage.data" />
        </v-card-text>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BarChart from "../charts/Doughnut";

export default {
  name: "StatusChart",
  props: {
    obj: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isActive: false,
      vals: [],
      rgb: [],
      dateUsage: {},
    };
  },
  created() {
    this.get_vals();
  },
  mounted() {
    if (!this.dateUsage) this.get_vals();
  },
  methods: {
    get_vals() {
      let vals = [];
      let rgb = [];
      let headers = [];
      let border = [];
      for (let i = 0; i < this.obj.length; i++) {
        const element = this.obj[i];
        if (parseFloat(element.val) > 0) {
          headers.push(`${element.val}%`);
          vals.push(element.val);
          rgb.push(`rgba(${element.color})`);
          border.push("grey");
        }
      }
      this.dateUsage = {
        headers: headers,
        data: [
          {
            backgroundColor: rgb,
            data: vals,
            borderColor: border,
            borderWidth: 0.6,
            borderAlign: "inner",
          },
        ],
      };
    },
  },
  components: {
    BarChart,
  },
};
</script>
